import React, { useEffect, useState } from "react";
import { Auth } from "aws-amplify";
import { Link } from "react-router-dom";
import AudioRetention from "./AudioRetention";
import ChangeEmail from "./ChangeEmail";
import ChangePassword from "./ChangePassword";
import s from "./Setting.module.scss";

const Settings = () => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    async function getData() {
      const data = await Auth.currentAuthenticatedUser();
      setUserData(data);
    }
    getData();
  }, []);

  return (
    <div className={s.pageContainer}>
      <div className={s.pageContent}>
        <div className={s.pageTitle}>Settings</div>
        <div className={s.sections}>
          <div className={s.section}>
            <ChangeEmail userData={userData} />
          </div>
          <div className={s.section}>
            <ChangePassword userData={userData} />
          </div>
        </div>
        <div className={s.sections}>
          <div className={s.section}>
            <div className={s.sectionTitle}>API Keys</div>
            <div className={s.sectionText}>Create and manage keys for external API access.</div>
            <Link to="/settings/api-keys" className={s.sectionLink} id="settings_api_keys_link">
              Manage API Keys
            </Link>
          </div>
          <div className={s.section}>
            <AudioRetention />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
